import Vue from 'vue';

/**
 * Responsive variable for whether the skyflok browser tab is mobile-size (<786px).
 * It reacts to window resizes.
 * 
 * Usage:
 * 1) Import this script: `import { useResponsive } from '@/helpers/useResponsive';`
 * 2) Declare a computed property that returns isMobile: `return useResponsive().isMobile;`
 * 
 */

const MOBILE_WIDTH_PX = 768

// Initial state
const state = Vue.observable({
  isMobile: window.innerWidth < MOBILE_WIDTH_PX
});

// State update
window.addEventListener('resize', () => {
  state.isMobile = window.innerWidth < MOBILE_WIDTH_PX;
});

export function useResponsive() {
  return state;
}
